'use client'

import { useLocale } from '@/contexts/LocaleContext'
import Image from 'next/image'

export default function LanguageSwitcher() {
  const { locale, setLocale } = useLocale()

  const languages = [
    { code: 'pt', flag: '/flags/br.svg', alt: 'Português (BR)' },
    { code: 'en', flag: '/flags/en.svg', alt: 'English (US)' },
  ] as const

  return (
    <div className="flex gap-4 items-center">
      {languages.map(({ code, flag, alt }) => (
        <button
          key={code}
          onClick={() => setLocale(code)}
          disabled={locale === code}
          className={`cursor-pointer transition-opacity hover:opacity-100 ${
            locale === code ? 'opacity-100' : 'opacity-50'
          }`}
        >
          <Image
            src={flag}
            alt={alt}
            width={36}
            height={36}
          />
        </button>
      ))}
    </div>
  )
}
